import { TemperatureUnit, UnLocationCodeDto } from '@admin/app/api'

export interface TenantConfigFormProfile {
  id?: number
  name: string
  timezone: string
  culture?: string
  address?: string | null
  truckArrivalWindowDuration?: number | null
  unloCodes?: UnLocationCodeDto[]
  hasDamageCatalogue?: boolean
  reeferContainerMaxUnpluggedTime?: number | null
  temperatureUnit?: TemperatureUnit
  allocationRuleWarningThreshold?: number | null
  blockWarningThreshold?: number | null
  yardWarningThreshold?: number | null
  yardMapAnchorLatitude?: number | null
  yardMapAnchorLongitude?: number | null
  yardMapNorthRotationDegrees?: number | null
}

export const defaultValues: TenantConfigFormProfile = {
  name: '',
  timezone: '',
  culture: '',
  address: '',
  unloCodes: [],
  hasDamageCatalogue: false,
  temperatureUnit: TemperatureUnit.Celsius,
  allocationRuleWarningThreshold: null,
  blockWarningThreshold: null,
  yardWarningThreshold: null,
}
